import React from 'react';
import moment from 'moment';
import { useTicker } from '../../hooks/useTicker';

const Ticker = ({
	date,
	periodMs = 30_000,
	titleFormat = 'YYYY-MM-DD HH:mm:ss',
	fromNow = true,
}) => {
	useTicker(periodMs); // causes a re-render for *all* TimeAgo instances together
	return (
		<span title={moment(date).format(titleFormat)}>
			{fromNow ? moment(date).fromNow() : moment(date).format('MM/DD - hh:mmA')}
		</span>
	);
};

export default Ticker;
